import React from 'react';
import { Footer } from '@/components/layout/Footer';
import { CmsThemedFooter } from '@/components/cms-theme/CmsThemedFooter';
import { CustomFooter } from '@/components/custom-theme/CustomFooter';
import { useContentMode } from '@/hooks/useContentMode';

/**
 * Switches between Hydra Design, Custom Design, and fallback footers
 * based on the current content mode.
 */
export const AdaptiveFooter: React.FC = () => {
  const { isHydraMode, isCustomMode } = useContentMode();
  
  if (isHydraMode) return <CmsThemedFooter />;
  if (isCustomMode) return <CustomFooter />;
  
  return <Footer />;
};
